export default __webpack_public_path__ + "static/media/nft-3.cd25fe18.png";